import React from "react";
import { useIntl } from "react-intl";

import Chip from "../../ChipIndicator";

interface ISitzeIndicator {
  filter: [number, number] | number | null;
  dispatch?: any;
}

const SitzeIndicator = ({
  filter,
  dispatch,
}: ISitzeIndicator): JSX.Element | null => {
  const { formatMessage: t } = useIntl();

  if (!filter) return null;

  const label =
    Array.isArray(filter) && filter[0] !== filter[1]
      ? t(
          {
            id: "common.sitze.span",
            defaultMessage: "{from} bis {to} Sitze",
          },
          { from: filter[0], to: filter[1] }
        )
      : t(
          {
            id: "common.sitze.plural",
            defaultMessage:
              "{count, plural, =0 {kein Sitz} one {ein Sitz} other {# Sitze}}",
          },
          { count: Array.isArray(filter) ? filter[0] : filter }
        );

  const handleDelete = (sitze: any) => {
    dispatch({
      type: "UPDATE_FILTER",
      payload: { sitze: null },
    });
  };

  return (
    <Chip id="sitze" label={label} onDelete={() => handleDelete("sitze")} />
  );
};

export default SitzeIndicator;
